
import React, { useState, useEffect } from 'react';

const Tower: React.FC = () => {
  const [blocks, setBlocks] = useState<{ x: number, w: number, y: number }[]>([{ x: 100, w: 200, y: 0 }]);
  const [currentX, setCurrentX] = useState(0);
  const [direction, setDirection] = useState(1);
  const [gameOver, setGameOver] = useState(false);

  const stackHeight = 25;
  const canvasWidth = 400;

  useEffect(() => {
    if (gameOver) return;
    const timer = setInterval(() => {
      setCurrentX(x => {
        const next = x + (direction * 5);
        if (next > canvasWidth - blocks[blocks.length-1].w || next < 0) {
          setDirection(d => d * -1);
          return x;
        }
        return next;
      });
    }, 20);
    return () => clearInterval(timer);
  }, [direction, blocks, gameOver]);

  const place = () => {
    const prev = blocks[blocks.length - 1];
    const newW = prev.w - Math.abs(currentX - prev.x);
    if (newW <= 0) {
      setGameOver(true);
      return;
    }
    setBlocks([...blocks, { x: Math.max(currentX, prev.x), w: newW, y: blocks.length * stackHeight }]);
  };

  return (
    <div className="flex flex-col items-center">
      <div className="mb-4 text-2xl font-black">UNITS: {blocks.length - 1}</div>
      <div className="w-[400px] h-[400px] bg-slate-900 relative overflow-hidden border-4 border-slate-800 rounded-xl" onClick={place}>
        {blocks.map((b, i) => (
          <div key={i} className="absolute bg-blue-500 border border-white/10" style={{ left: b.x, width: b.w, bottom: b.y, height: stackHeight }} />
        ))}
        {!gameOver && (
          <div className="absolute bg-blue-300" style={{ left: currentX, width: blocks[blocks.length-1].w, bottom: blocks.length * stackHeight, height: stackHeight }} />
        )}
      </div>
      {gameOver && <button onClick={() => window.location.reload()} className="mt-6 bg-blue-600 px-8 py-2 rounded-full font-bold">REBUILD SERVER</button>}
    </div>
  );
};

export default Tower;
